// 查人员接口
import request from '@/utils/request'

// 获取首页企业，人员，项目总数
export const homeCountTotal = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/home/homeCountTotal',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: false
		},
		params
	})
}

// 分页查人员证书列表
export const pagePersonCertificate = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查人员证书列表（高级查询）
export const pageTabAdvancedQuery = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/pageTabAdvancedQuery',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 根据人员id分页查询当前用户所有的证书
export const pageCertificateByPersonId = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificate/pageByPersonId',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查人员详情
export const getPersonDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询个人工程业绩
export const pageUserProjectPerformanceTab = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/pageUserProjectPerformanceTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询个人业绩技术指标表
export const personTechnicalIndexPageTab = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personTechnicalIndex/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询个人行为表
export const personBehaviorRecordPageTab = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personBehaviorRecord/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 根据id查询个人行为表 0不良行为 1良好行为 2行政处罚 3黑名单 4黑名单及联合惩戒
export const personBehaviorRecordGetById = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personBehaviorRecord/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询个人风险提醒详情-根据id查询个人行为表 不消耗次数 且id加密
export const getPersonWarningDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personBehaviorRecord/getInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询人员信息 0待注册，1已注册，2非注册
export const personRecordPageTab = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 个人证书历史许可记录
export const getCertificateInfoVoList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personCertificateHis/getCertificateInfoVoList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-人员画像分析
export const personPortrayal = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/getPersonPortrait',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-人员证书数量分析
export const personCerCountRank = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/getPersonCerCountRank',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-人员证书分类分析
export const personCerTypeCount = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/listPersonCerTypeCount',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-人员证书等级分析
export const personCerGradeRank = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/getPersonCerGradeRank',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-获取人员风险分析（近一年）
export const personRisk = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personBehaviorRecord/getPersonRisk',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-根据月份分组，获取当前人员的稳定性分析(近一年)
export const personStability = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/getPersonStability',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-个人行为记录分析
export const personBehavior = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personBehaviorRecord/listPersonBehavior',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-人员报告导出
export function exportPersonReport() {
	return process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/personRecord/exportPersonReport'
}
